/*eslint-disable*/
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import classNames from "classnames";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Footer from "components/Footer/Footer.js";
import Mail from "@material-ui/icons/Mail";

import styles from "assets/jss/material-kit-pro-react/views/componentsSections/footerStyle.js";

const useStyles = makeStyles(styles);

export default function SectionFooter() {
  const classes = useStyles();
  return (
    <Footer
      theme="white"
      content={
        <div>
          {/* <ul className={classes.socialButtons}>
            <li>
              <Button justIcon simple href="#pablo" color="twitter">
                <i className="fab fa-twitter" />
              </Button>
            </li>
            <li>
              <Button justIcon simple href="#pablo" color="facebook">
                <i className="fab fa-facebook-square" />
              </Button>
            </li>
            <li>
              <Button justIcon simple href="#pablo" color="dribbble">
                <i className="fab fa-dribbble" />
              </Button>
            </li>
            <li>
              <Button justIcon simple href="#pablo" color="google">
                <i className="fab fa-google-plus-g" />
              </Button>
            </li>
            <li>
              <Button justIcon simple href="#pablo" color="youtube">
                <i className="fab fa-youtube" />
              </Button>
            </li>
          </ul> */}
          <div
            className={classNames(classes.pullCenter, classes.copyRight)}
          >
            &copy; {1900 + new Date().getYear()}{" "}
            <a
            //   href="https://www.creative-tim.com?ref=mkpr-footer-components"
            //   target="_blank"
            >
              B2B INDIAN BANGLES
            </a>
          </div>
        </div>
      }
    >
      <div className={classes.footer}>
        <GridContainer>
          <GridItem xs={12} sm={3} md={3}>
            <a href="/">
              <h5>B2B INDIAN BANGLES</h5>
            </a>
            {/* <p>
                  Probably the best UI Kit in the world! We know you{"'"}ve been
                  waiting for it, so don{"'"}t be shy!
                </p> */}
          </GridItem>
          <GridItem xs={12} sm={2} md={2}>
            {/* <h5>About</h5> */}
            {/* <ul className={classes.linksVertical}>
                  <li>
                    <a href="#pablo">Blog</a>
                  </li>
                  <li>
                    <a href="#pablo">About us</a>
                  </li>
                  <li>
                    <a href="#pablo">Contact us</a>
                  </li>
                </ul> */}
          </GridItem>
          <GridItem xs={12} sm={2} md={2}>
            {/* <h5>Market</h5> */}
            <ul className={classes.linksVertical}>
              <li>
                <a href="/privacyPolicy">Privacy Policy</a>
              </li>
              <li>
                <a href="/return-policy">Return Policy</a>
              </li>
              <li>
                <a href="/refund-policy">Refund Policy</a>
              </li>
            </ul>
          </GridItem>
          <GridItem xs={12} sm={2} md={2}>
            {/* <h5>Legal</h5> */}
            <ul className={classes.linksVertical}>
              <li>
                <a href="/terms-and-conditions">Terms & Conditions</a>
              </li>
              <li>
                <a href="/license">License</a>
              </li>
              <li>
                <a href="/Shipping">Shipping</a>
              </li>
            </ul>
          </GridItem>
          <GridItem xs={12} sm={3} md={3}>
            <h5>Subscribe to Newsletter</h5>
            <p>
              Join our newsletter and get news in your inbox every week! We
              hate spam too, so no worries about this.
            </p>
            {/* <form>
              <CustomInput
                id="footeremail"
                formControlProps={{
                  fullWidth: false,
                  className: classes.customFormControl,
                }}
                inputProps={{
                  placeholder: "Your Email...",
                }}
              />
              <Button color="primary" justIcon>
                <Mail />
              </Button>
            </form> */}
          </GridItem>
        </GridContainer>
      </div>
    </Footer>
  );
}
